"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = markTerm;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Replaces matching terms in a string with markers.
 *
 * @param {string} content The content to parse and mark.
 *
 * @param {string} term The term to search and replace in the content. Case
 * sensitive.
 *
 * @param {Function} tag A function that takes the matched term and must return
 * a React component or a string. The value returned by that function will
 * replace the term in the output.
 *
 * @returns {Array} An array of strings and React components, similar to the
 * original content but where each matching term has been replaced by a
 * marking component.
 */
function markTerm(content, term, tag) {
  var output = [];
  var pos = content.indexOf(term);

  if (pos === -1) {
    return [content];
  }

  var parts = content.split(term);

  for (var i = 0; i < parts.length - 1; i++) {
    if (parts[i]) {
      output.push(parts[i]);
    }

    output.push(tag(term));
  }

  if (parts[parts.length - 1]) {
    output.push(parts[parts.length - 1]);
  }

  return output;
}